import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";

export const ObjectTable: React.FC<{ data: Record<string, unknown>[] }> = ({
    data,
}) => {
    if (data.length === 0) {
        return <></>;
    }

    const head = Object.keys(data[0]);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        {head.map(x => (
                            <TableCell key={x}>{x}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((r, i) => {
                        return (
                            <TableRow key={i}>
                                {Object.values(r).map((s, j) => (
                                    <TableCell key={head[j]}>
                                        {String(s)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
